import { addError } from 'action-creators/ErrorActionCreators';
import { connect } from 'react-redux';

import ProjectTradeList from '../components/sequences/ProjectTradeList';

const mapStateToProps = (state, _ownProps) => ({
  projectTradeIds: state.domain.projectTradeCollection.allDataIds,
  isSorting: state.ui.ordering.projectTrades,
  projectId: state.application.projectId,
});

const mapDispatchToProps = (dispatch, _ownProps) => ({
  dispatch,
  addError: (errorKey, payload) => dispatch(addError(errorKey, payload)),
});

const AvailableProjectTradeList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectTradeList);

export default AvailableProjectTradeList;
